import styled from 'styled-components';

export const PartnerLogo = styled.img`
  width: ${props => props.theme.space['40']};

  ${props => props.theme.mediaQueries.smallDown} {
    width: ${props => props.theme.space['33']};
  }

  ${props => props.theme.mediaQueries.smallWidthAndHeightDown} {
    width: ${props => props.theme.space['29']};
  }

  margin-bottom: ${props => props.theme.space.s7};
`;
